import styled from 'styled-components';

const Container = styled.div`
  text-align: left;
  box-sizing: border-box;
  min-height: 54px;
  width: 100%;
  padding-top: 12px;
  position: ${({ position }) => position || 'relative'};

  :last-child {
    margin-bottom: ${({ showMessage }) => (showMessage ? '16px' : '0px')};
  }
  :last-of-type {
    margin-bottom: ${({ showMessage }) => (showMessage ? '16px' : '0px')};
  }
`;

export default Container;
